import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Router from './screens/Router/Router';
import Ripple from './components/UI/Ripple/Ripple';
import { getHub } from './redux/actions';

const App = () => {
  const hub = useSelector((state) => state.hub.hub);
  const loading = useSelector((state) => state.hub.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hub === null) {
      dispatch(getHub(process.env.REACT_APP_HUB_ID));
    }
  }, [dispatch, hub]);

  return loading || hub === null ? <Ripple /> : <Router />;
};

export default App;
